/**
 * The app's one `import()` of `@rogoag/mission`. The package carries a ~2 MB WASM core; loading it on
 * first use keeps it off the app's critical path (only the job panel, the ops maps and DevMap ever
 * parse a mission). Every adapter that needs the package's values (`MissionsLoader`, `MissionRuntime`)
 * goes through this function, so the bundle holds exactly one deferred import of it, the one
 * `deferred_imports["@rogoag/mission"]` pins in `Web/perf-critical-path.json`.
 */
export const missionPackage = () => import("@rogoag/mission");
